const useAccordionBlock = (accordion: HTMLElement): void => {
  const details = accordion.querySelector<HTMLDetailsElement>(".accordion-block__content");
  const button = details?.querySelector<HTMLElement>(".accordion-block__title");
  const panel = details?.querySelector<HTMLElement>(".accordion-block__panel");

  if (!details || !button || !panel) {
    return;
  }
  
  const toggleTabableElements = (isEnabled: boolean) => {
    const tabableElements = panel.querySelectorAll<HTMLElement>(
      'a, button, input, details, [tabindex]:not([tabindex="-1"])'
    );

    tabableElements.forEach((el) => {
      if (isEnabled) {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', '-1');
      }
    });
  };

  // Initial state: closed
  panel.style.maxHeight = "0px";
  accordion.classList.remove("accordion-block--is-open");

  button.addEventListener("click", () => {
    const isOpen = accordion.classList.contains("accordion-block--is-open");

    toggleTabableElements(!isOpen);

    if (isOpen) {
      // CLOSE: from current content height -> 0 with animation
      // max-height might be "none", set it to the current scrollHeight first to be sure that we have a value
      panel.style.maxHeight = panel.scrollHeight + "px";
      // Force reflow so the browser registers the current height before we set it to 0
      void panel.offsetHeight;
      // Then animate to 0
      panel.style.maxHeight = "0px";
      accordion.classList.remove("accordion-block--is-open");
      button.setAttribute("aria-expanded", "false");
    } else {
      // OPEN: from 0 -> scrollHeight
      panel.style.maxHeight = panel.scrollHeight + "px";
      accordion.classList.add("accordion-block--is-open");
      button.setAttribute("aria-expanded", "true");
    }
  });

  // When opening finishes, remove max-height limit so content can grow naturally
  panel.addEventListener("transitionend", () => {
    if (accordion.classList.contains("accordion-block--is-open")) {
      panel.style.maxHeight = "none";
    }
  });
};

const accordions: NodeListOf<HTMLElement> = document.querySelectorAll(".accordion-block");

accordions.forEach((accordion) => {
  useAccordionBlock(accordion);
});

// Optional: keep height correct on resize for open panels
window.addEventListener("resize", () => {
  const openPanels: NodeListOf<HTMLElement> =
    document.querySelectorAll(".accordion-block.accordion-block--is-open .accordion-block__panel");

  openPanels.forEach((panel) => {
    const element = panel as HTMLElement;
    // If we are limiting height (not 'none'), recalc it
    if (element.style.maxHeight !== "none") {
      element.style.maxHeight = element.scrollHeight + "px";
    }
  });
});